import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { catalogTranslationRef } from '@backstage/plugin-catalog';

export const catalogTranslations = createTranslationMessages({
  ref: catalogTranslationRef,
  messages: {
    'indexPage.createButtonTitle': 'Self Service',
  },
});
